import { Box } from "@chakra-ui/react";
import { renderGlobalComponent } from "modules/storyblok/templates/GlobalTemplate";
import type { GlobalComponentsWrapperProps } from "./types";

export const GlobalComponentsWrapper = ({
  children,
  globalComponents,
  globalComponentsProps: { footer, header } = {
    footer: { hideFlagBox: false },
    header: {
      headerActionButton: "view-claim-status",
      hideFlagBox: false,
    },
  },
}: GlobalComponentsWrapperProps) => (
  <>
    {renderGlobalComponent(globalComponents.header, header)}
    <Box as="main" mt={{ base: 28, lg: 44 }}>
      {children}
    </Box>
    {renderGlobalComponent(globalComponents.footer, footer)}
  </>
);
